/**
 * 角色管理接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RoleManagementService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   //任务调度微服务api
   activitiWebAPI: string = environment.activitiWebAPI;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 角色管理接口
   /**
   * 查询角色管理总数据
   * @param param
   * @returns {Observable<any>}
   */
  getRoleList(sysId) {
    const url = this.prefix + 'role/queryAssignRole?systemId='+sysId;
    return this.http.Get(url);
  }
  /**
   * 分页查询角色管理
   * @param param
   * @returns {Observable<any>}
   */
  queryRolePageList(param) {
    const url = this.prefix + 'role/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 删除角色管理
   * @param param
   * @returns {Observable<any>}
   */
  deleteRole(param) {
    const url = this.prefix + 'role/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 修改,启用，禁用角色管理
   * @param param
   * @returns {Observable<any>}
   */
  updateRole(param) {
    const url = this.prefix + 'role/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 新增角色管理
   * @param param
   * @returns {Observable<any>}
   */
  saveRole(param) {
    const url = this.prefix + 'role/save';
    return this.http.Post(url, param);
  }

  /**
   * 查询单个角色管理信息
   * @param param
   */
  getRole(param) {
    const url = this.prefix + 'role/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 保存或删除用户(维护用户)
   * @param param
   */
  saveOrDeleteRoleUser(param) {
    const url = this.prefix + 'userRole/saveOrDelete';
    return this.http.Post(url, param);
  }

  /**
   * 查找角色,用户关联表信息（维护用户）
   * @param param
   */
  queryUserRoleByFk(param) {
    const url = this.prefix + 'userRole/queryByFk';
    return this.http.Post(url, param);
  }

  /**
   * 查询左侧组织树（维护用户）
   * @param param
   * @returns {Observable<any>}
   */
  queryOrganizeTree(param) {
    const url = this.prefix + 'organize/queryTree';
    return this.http.Post(url, param);
  }

  /**
   * 无管理权限获取角色列表
   * @param param
   * @returns {Observable<any>}
   */
  queryList(param) {
    const url = this.activitiWebAPI + 'role/queryList';
    return this.http.Post(url, param);
  }
  //#endregion




}
